<tp-feed-back-form *ngIf="batchDetails.userType === 'tp'" [batchDetails]="batchDetails"></tp-feed-back-form>

<trainer-feedback-form *ngIf="batchDetails.userType === 'trainer'"  [batchDetails]="batchDetails"> </trainer-feedback-form>	